import React from 'react'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
const TopBarCalendar = ({schoolCalendar, setSchoolCalendar, createNewPendingOffer, createNewCalendarEvent}) => {
    const [schools, setSchools] = React.useState([])

    React.useEffect(() => {
        axios.get(`${baseUrl}/schools`)
        .then(res => {
          setSchools(res.data)
          setSchoolCalendar(res.data.filter((e) => e.schoolAbbreviation === 'MMA')[0])
        })
        .catch(err => console.log(err))
      }, [])

      const chooseTheSchool = (id) => {
        setSchoolCalendar(schools.filter(school => school.id === id)[0])
      }

    return(
        <div className='border border-solid border-gray-300 pb-4 border-t-0 border-l-0 border-r-0 ml-72 mr-28'>
            <div className=' text-3xl font-bold mt-4 ml-1 inline-block'>Calendar</div>
            {schoolCalendar && 
              <div className="ml-5 mr-0 inline-block align-top mt-4">
                <select className="text-sm text-left py-2 border-gray-300 p-2 pr-8 align-top rounded-3xl focus:border-gray-300 focus:outline-none " value={schoolCalendar.id} onChange={(e) => chooseTheSchool(e.target.value)}>
                  {schools.map((school) => (
                    <option key={school.id} value={school.id}>{school.name}</option>
                  ))}
                </select>
              </div>
            }
              {/* <button
                  type="button" onClick={() => createNewPendingOffer()} className="ml-6 cursor-pointer float-right mt-4 rounded-3xl border border-transparent border-black bg-white py-2 px-4 text-sm font-medium text-black shadow-sm hover:bg-white hover:shadow-xl transition-shadow duration-300 focus:outline-none"
                >
                  Add Offer +
                </button> */}
                <button onClick={() => createNewCalendarEvent()} type="button" className="ml-6 cursor-pointer float-right mt-4 rounded-3xl border border-transparent border-blue-600 text-blue-600 bg-white py-2 px-4 text-sm font-medium shadow-sm hover:bg-white hover:shadow-xl transition-shadow duration-300 focus:outline-none">
                New Event +
              </button>
          </div>
    )
}
export default TopBarCalendar